module.exports = __webpack_public_path__ + "img/ic_episodes.e8eb2341.svg";